const ProgressStatusEnum = {
  notSubmitted: 'NOT_SUBMITTED',
  pending: 'PENDING',
  approved: 'APPROVED',
  rejected: 'REJECTED',
  completed: 'COMPLETED',
  complete: 'COMPLETE',
  inComplete: 'IN_COMPLETE',
  notAttempted: 'NOT_ATTEMPTED'
};

export { ProgressStatusEnum };
export default ProgressStatusEnum;
